module.exports = __webpack_public_path__ + "static/media/shuffle-icon.c27a0e86.svg";